import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "../icon-component.types";

export const IconBold: TIconComponent = props => (
    <Icon viewBox="0 0 12 16" fill="none" {...props}>
        <path
            d="M8.25 7.99998L1.75 7.99998M8.25 7.99998C8.25 7.99998 10.25 9 10.25 11.5C10.25 13.5 8.82646 14.5 7.25 14.5C5.67354 14.5 1.75 14.5 1.75 14.5V7.99998M8.25 7.99998C8.25 7.99998 10.25 7 10.25 5C10.25 2.5 7.95 1.50001 7.25 1.5C6.55 1.5 1.75 1.5 1.75 1.5V7.99998"
            stroke="#333333"
            strokeWidth="3"
            strokeLinejoin="round"
        />
    </Icon>
);
